export function hashRouter(routes: object) {
  const route = () => {
    const hash = window.location.hash.replace("#", "") || "/";
    const view = routes[hash] || routes["/404"];
    if (typeof view === "function") view();
  };

  route();
  const handler = () => route();
  window.addEventListener("hashchange", handler);

  return {
    route,
    dispose() {
      window.removeEventListener("hashchange", handler);
    },
  };
}
